/**
 * @see https://umijs.org/docs/max/access#access
 */

export interface CurrentUser {
  id: number;
  username: string;
  full_name: string;
  role: 'admin' | 'counter' | 'viewer';
}

export default function access(
  initialState: { currentUser?: CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const role = currentUser?.role;

  return {
    // Admin only
    isAdmin: role === 'admin',

    // Admin or Counter staff
    isCounter: role === 'admin' || role === 'counter',

    // Admin or Viewer
    canReports: role === 'admin' || role === 'viewer',

    // Any authenticated user
    isAuthenticated: !!currentUser,
  };
}
